export default "__VITE_ASSET__F2BQJ0v$__"